import React from 'react';
import Logo from '../images/Logo-Color.svg';
import Dribbble from '../images/Dribbble-logo.svg';
import Linkedin from '../images/Linkedin-logo.svg';
import Medium from '../images/Medium-logo.svg';
import './Footer.scss'; 

const Footer = () => {

    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className='footer-contact'>
                <h2>Let's Work Together.</h2>
                <p>Drop Me A Line For More Recent Work And Collaboration.</p>
                <h6><a href="kshitighelani@gmail.com">kshitighelani@gmail.com →</a></h6>
            </div>
            <div className='footer-top'>
                <div className='row'>
                    <div className='col-85 footer-col-1'>
                        <a href='/' className='footer-logo'><img src={Logo} alt="Kshiti color logo"/></a>
                        <div className='footer-content'>
                            <h2>Kshiti Ghelani</h2>
                            <h6>Front-End Designer And Developer</h6>
                            <div className='footer-social footer-social-desktop'>
                            <a href='https://www.linkedin.com/in/kshiti-ghelani/' target='_blank' className='footer-social-logo'><img src={Linkedin} alt="Linkedin logo"/></a>
                                <a href='https://dribbble.com/kshiti_ghelani' target='_blank' className='footer-social-logo'><img src={Dribbble} alt="Dribbble logo"/></a>
                                <a href='https://medium.com/@kshitighelani' target='_blank' className='footer-social-logo'><img src={Medium} alt="Medium logo"/></a>
                            </div>
                        </div>
                    </div>
                    <div className='col-15 footer-col-2'>
                        <ul>
                        <a href="/about">About</a>
                        <a href="/portfolio">Portfolio</a>
                        <a href="/artstudio">Art Studio</a>
                        <a href="https://medium.com/@kshitighelani" target='_blank'>Blog</a>
                        <a href="/contact">Contact</a>
                        </ul>
                        <div className='footer-social footer-social-mobile'>
                            <a href='https://www.linkedin.com/in/kshiti-ghelani/' target='_blank' className='footer-social-logo'><img src={Linkedin} alt="Linkedin logo"/></a>
                            <a href='https://dribbble.com/kshiti_ghelani' target='_blank' className='footer-social-logo'><img src={Dribbble} alt="Dribbble logo"/></a>
                            <a href='https://medium.com/@kshitighelani' target='_blank' className='footer-social-logo'><img src={Medium} alt="Medium logo"/></a>
                        </div>
                    </div>
                </div>
            </div>
            <div className='footer-bottom'>
                <p>© {currentYear} Copyright: Kshiti | All Rights Reserved</p>
            </div>
        </footer>
    );
};

export default Footer;